import {Stack, Typography} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import FlatInput from '../../../../../../../components/flat-input/flat-input';
import {Modal} from '../../../../../../../components/modal/modal';
import {translations} from '../../../../../../../i18n/translations';

export const AI_FOCUS_MAX_CHARACTERS = 500;

/**
 * Asks how the AI should generate the individual plan: with a free-text focus or automatically.
 * The focus only indicates the clinical topic, it is not an instruction to the AI.
 */
export const AiGenerateDialog = ({
  onGenerate,
  onClose,
}: {
  // `focus` is undefined for the automatic plan
  onGenerate: (focus?: string) => void;
  onClose: () => void;
}) => {
  const {t} = useTranslation();
  const labels = translations.seniors.edit.senior_dcm.individual_plan.ai_generate;
  const [focus, setFocus] = useState<string>('');
  const trimmedFocus = focus.trim();

  return (
    <Modal
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      preventCloseClick
      title={t(labels.title)}
      actionButton={{type: 'close'}}
      actions={[
        {
          label: t(labels.automatic),
          type: 'neutral',
          onClick: () => onGenerate(),
        },
        {
          label: t(labels.with_focus),
          type: 'nondestructive',
          onClick: () => onGenerate(trimmedFocus),
          disabled: trimmedFocus === '',
        },
      ]}
    >
      <Stack gap="16px">
        <Typography sx={{fontSize: '14px', opacity: 0.7}}>{t(labels.description)}</Typography>
        <FlatInput
          multiline
          minRows={3}
          value={focus}
          label={t(labels.focus_label)}
          placeholder={t(labels.focus_placeholder)}
          counter={{current: focus.length, max: AI_FOCUS_MAX_CHARACTERS}}
          inputProps={{maxLength: AI_FOCUS_MAX_CHARACTERS}}
          onChange={(event) => setFocus(event.target.value)}
        />
      </Stack>
    </Modal>
  );
};
